// extracted by mini-css-extract-plugin
module.exports = {"title":"project-module--title--3gUmK","photos":"project-module--photos--3Zn_g"};